import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import _ from 'lodash';
import {
    Container,
    ContentSumary,
    GridColTemplate,
    FlexGridSixthTemplate
} from "./SummaryOverview.styles";
import SummarySettingActions from "../../../actions/GuestSummarySetting";

const SummaryOverview = () => {
    const { i18n } = useTranslation();
    const dispatch = useDispatch();
    const summarySetting = useSelector((state) => state.GuestSummarySetting.summaryData);

    const [informationTwo, setInformationTwo] = useState(summarySetting.informationTwo);
    const [informationThree, setInformationThree] = useState(summarySetting.informationThree);
    const [informationFive, setInformationFive] = useState(summarySetting.informationFive);

    useEffect(() => {
        dispatch(SummarySettingActions.getSummarySettingData());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setInformationTwo(summarySetting.informationTwo);
        setInformationThree(summarySetting.informationThree);
        setInformationFive(summarySetting.informationFive);
    }, [summarySetting]);

    return (
        <Container>
            <ContentSumary>
                <FlexGridSixthTemplate>
                    <GridColTemplate>
                        <div className="container-item">
                            <div className="number">{_.get(informationTwo, 'value', 0)}</div>
                            <div className="description">{_.get(informationTwo, i18n.language === "en" ? "name" : "nameAl", 'Not Set')}</div>
                        </div>
                    </GridColTemplate>
                    <GridColTemplate className="flex-center">
                        <div className="split-container">
                            <div className="diamon" />
                        </div>
                    </GridColTemplate>
                    <GridColTemplate>
                        <div className="container-item">
                            <div className="number">{_.get(informationThree, 'value', 0)}</div>
                            <div className="description">{_.get(informationThree, i18n.language === "en" ? "name" : "nameAl", 'Not Set')}</div>
                        </div>
                    </GridColTemplate>
                    <GridColTemplate className="flex-center">
                        <div className="split-container">
                            <div className="diamon" />
                        </div>
                    </GridColTemplate>
                    <GridColTemplate>
                        <div className="container-item">
                            <div className="number">{_.get(informationFive, 'value', 0)}</div>
                            <div className="description">{_.get(informationFive, i18n.language === "en" ? "name" : "nameAl", 'Not Set')}</div>
                        </div>
                    </GridColTemplate>
                </FlexGridSixthTemplate>
            </ContentSumary>
        </Container>
    );
};

export default SummaryOverview;
